/**
 * @flow
 * @relayHash 3453c861d3e4245211709c49c6acaf82
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetNonTradeUserToSuspectedTradeInput = {|
  userId: string,
  clientMutationId?: ?string,
|};
export type setNonTradeUserToSuspectedTradeMutationVariables = {|
  input: SetNonTradeUserToSuspectedTradeInput
|};
export type setNonTradeUserToSuspectedTradeMutationResponse = {|
  +setNonTradeUserToSuspectedTradeMutation: ?{|
    +verifiedTradeStatus: ?string
  |}
|};
export type setNonTradeUserToSuspectedTradeMutation = {|
  variables: setNonTradeUserToSuspectedTradeMutationVariables,
  response: setNonTradeUserToSuspectedTradeMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetNonTradeUserToSuspectedTradeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetNonTradeUserToSuspectedTradeInput!"
      }
    ],
    "concreteType": "SetNonTradeUserToSuspectedTradePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "verifiedTradeStatus",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "id": "dibs-buyer-layout/222.6.0-2019-06-25T11:58:43.302Z/setNonTradeUserToSuspectedTradeMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0a90bfe522581c99eb190f2a4f33421c';
module.exports = node;
